export default __webpack_public_path__ + "static/media/tutorial-2.3c1d4562.svg";